import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Auteur"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Mail auteur"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Talent commenté"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Commentaire"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Type d'avis"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0 pe-0" }, "Actions")
  ])
], -1)
const _hoisted_9 = {
  key: 0,
  class: "badge bg-warning text-dark ms-2",
  style: {"font-size":"10px"}
}
const _hoisted_10 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_11 = { class: "dropdown" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown"
}, " Actions ", -1)
const _hoisted_13 = { class: "dropdown-menu" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-locked me-2" }, null, -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "dropdown-item text-muted",
  style: {"cursor":"not-allowed"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-locked me-2" }),
  /*#__PURE__*/_createTextVNode(" Désactiver (non signalé) ")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark me-2" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete me-2" }, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  class: "text-center py-3 text-body-tertiary"
}, "Aucun avis trouvé", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher un avis..."
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_4
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aviss, (avis) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: avis.id
              }, [
                _createElementVNode("td", null, _toDisplayString(avis.auteur?.nom || 'Inconnu') + " " + _toDisplayString(avis.auteur?.prenom || ''), 1),
                _createElementVNode("td", null, _toDisplayString(avis.auteur?.email || '-'), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(avis.talent?.nom || 'Inconnu') + " " + _toDisplayString(avis.talent?.prenom || '') + " ", 1),
                    (avis.talent?.profilSignale)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Signalé "))
                      : _createCommentVNode("", true)
                  ]),
                  (avis.talent && avis.talent.nombreAvisDefavorables > 0)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(avis.talent.nombreAvisDefavorables) + " avis défavorable(s) ", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(avis.commentaire || '-'), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass([avis.type === 'favorable' ? 'bg-success' : 'bg-danger', "badge"])
                  }, _toDisplayString(avis.type === 'favorable' ? 'Favorable' : 'Défavorable'), 3)
                ]),
                _createElementVNode("td", null, _toDisplayString(avis.dateCommentaire ? _ctx.format_date(avis.dateCommentaire) : '-'), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("ul", _hoisted_13, [
                      (avis.talent?.statut && avis.talent?.profilSignale)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                            _createElementVNode("a", {
                              class: "dropdown-item text-danger",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.desactiverTalent(avis.talent.id))
                            }, [
                              _hoisted_16,
                              _createTextVNode(" Désactiver le talent ")
                            ], 8, _hoisted_15)
                          ]))
                        : (avis.talent?.statut && !avis.talent?.profilSignale)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_17, _hoisted_19))
                          : _createCommentVNode("", true),
                      (avis.talent && !avis.talent.statut)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                            _createElementVNode("a", {
                              class: "dropdown-item text-success",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.reactiverTalent(avis.talent.id))
                            }, [
                              _hoisted_22,
                              _createTextVNode(" Réactiver le talent ")
                            ], 8, _hoisted_21)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_23,
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item text-danger",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.supprimerAvis(avis.id))
                        }, [
                          _hoisted_25,
                          _createTextVNode(" Supprimer l'avis ")
                        ], 8, _hoisted_24)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.aviss.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_26, _hoisted_28))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}